/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowasklogo3Inputs */

const en_aiflowasklogo3 = /** @type {(inputs: Aiflowasklogo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Should your logo go on the cover? We place the real logo from your profile, the AI never redraws it.`)
};

const de_aiflowasklogo3 = /** @type {(inputs: Aiflowasklogo3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soll dein Logo aufs Cover? Wir setzen das echte Logo aus deinem Profil ein, die KI zeichnet es nicht nach.`)
};

/**
* | output |
* | --- |
* | "Should your logo go on the cover? We place the real logo from your profile, the AI never redraws it." |
*
* @param {Aiflowasklogo3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowasklogo3 = /** @type {((inputs?: Aiflowasklogo3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowasklogo3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowasklogo3(inputs)
	return de_aiflowasklogo3(inputs)
});
export { aiflowasklogo3 as "aiFlowAskLogo" }